import { createTheme as a } from "./highrise678.mjs";
import e from "./highrise695.mjs";
import l from "./highrise775.mjs";
import i from "./highrise948.mjs";
import d from "./highrise949.mjs";
function c(o) {
  const {
    modalColor: r,
    textColor2: t,
    boxShadow3: m
  } = o;
  return {
    color: r,
    textColor: t,
    boxShadow: m
  };
}
const s = a({
  name: "Modal",
  common: d,
  peers: {
    Scrollbar: i,
    Dialog: l,
    Card: e
  },
  self: c
});
export {
  s as default,
  c as self
};
